import { makeAutoObservable } from 'mobx'
import { ClientsApi } from 'entities/Clients/api/clients'
import type { IResponsePendingClient, IResponsePendingClients } from 'entities/Clients/api/types'
import { RowPendingClient } from 'entities/Clients/model/RowPendingClient'
import { ClientsTabStore } from 'pages/clients/store/clientsTabStore'

export class PendingClientsTabStore {
  private readonly _base: ClientsTabStore<
    IResponsePendingClient,
    IResponsePendingClients,
    RowPendingClient
  >

  constructor() {
    this._base = new ClientsTabStore<
      IResponsePendingClient,
      IResponsePendingClients,
      RowPendingClient
    >({
      table: {
        key: 'pendingClientsTable',
        element: 'pendingClients',
      },
      request: (params) => ClientsApi.getPendingClients(params),
      makeRow: (item) => new RowPendingClient(item),
    })

    makeAutoObservable(this)
  }

  get tableStore() {
    return this._base.tableStore
  }

  get scrollToTopTrigger() {
    return this._base.scrollToTopTrigger
  }

  get itemsRows() {
    return this._base.itemsRows
  }

  init = () => this._base.init()

  onSuccessCancelInvite = () => {
    this._base.loadData()
  }

  dispose = () => {
    this._base.dispose()
  }
}
